export const CONFIG = {
  url: 'https://api.graphqlplaceholder.com/',
};
